import styled from 'styled-components/macro';

export const ScErrorBlock = styled.div`
  width: 100%;
  padding: 40px 30px;
`;
